module.exports = __webpack_public_path__ + "img/hourly.7783c68e.png";